import React from 'react';
import { 
  Typography, 
  Container, 
  Paper, 
  Divider, 
  Box,
  Link
} from '@mui/material';
import { PageHeader } from '../components/common/PageHeader';
import EmailIcon from '@mui/icons-material/Email';
import './ContactPage.css';

export const ContactPage: React.FC = () => {
  return (
    <div className="contact-page">
      <Container maxWidth="md" className="contact-container">
        <Paper elevation={2} className="contact-paper">
          {/* Header with back button and title */}
          <PageHeader title="Contact" titleVariant="h5" />

          {/* Warm Intro Text */}
          <Box className="contact-intro-section">
            <Typography paragraph className="contact-intro-text">
              Hey there! 👋 We'd love to hear from you! Whether you've got awesome feedback, found something that's bugging you, 
              have a cool idea, or just want to say hi – we're all ears. Your thoughts help us make CyclingBuddy better 
              for everyone, so don't be shy!
            </Typography>
          </Box>

          <Divider className="contact-divider" />

          {/* Contact Information Section */}
          <Typography 
            variant="h5" 
            component="h2" 
            className="contact-section-title"
            sx={{ 
              marginTop: { xs: '32px', sm: '48px' },
              '&.MuiTypography-root': { marginTop: { xs: '32px !important', sm: '48px !important' } }
            }}
          >
            Get in Touch
          </Typography>
          
          <Box className="contact-info-section">
            <Box display="flex" alignItems="center" justifyContent="center" gap={1} mb={2}>
              <EmailIcon color="primary" sx={{ fontSize: '2rem' }} />
              <Typography variant="h6" className="contact-text" sx={{ margin: 0 }}>
                <Link href="mailto:mario@cyclingbuddy.de" color="primary" sx={{ fontSize: '1.25rem', fontWeight: 500 }}>
                  mario@cyclingbuddy.de
                </Link>
              </Typography>
            </Box>
            <Typography variant="body1" color="text.secondary" className="contact-description" sx={{ textAlign: 'center' }}>
              We usually get back to you within a day (sometimes faster if we're excited about your message! ☕)
            </Typography>
          </Box>

          <Divider className="contact-divider" />

          <Typography paragraph className="contact-text" sx={{ textAlign: 'center', marginTop: 3 }}>
            For the legal stuff, check out our{' '}
            <Link href="/imprint" color="primary">
              Imprint
            </Link>
            {' '}and{' '}
            <Link href="/privacy-policy" color="primary">
              Privacy Policy
            </Link>
            .
          </Typography>
        </Paper>
      </Container>
    </div>
  );
};
